import coupler from 'utils/coupler'
import withRouter from 'utils/withRouter'

import handlers, { initialState } from 'handlers/settings'

import Account from 'components/Account'
import Billing from 'components/Billing'
import Integrations from 'components/Integrations'
import SideNav from 'components/SideNav'

const screens = {
  account: Account,
  billing: Billing,
  integrations: Integrations
}

const tabs = [
  { name: 'account', children: 'Account' },
  { name: 'integrations', children: 'Integrations' },
  { name: 'billing', children: 'Membership' }
]

function render() {
  const { handle, state, props: { account, integrations } } = this
  const Component = screens[state.selected]
  return (
    <div className='container page'>
      <div className='col-2'>
        <SideNav {...{ ...state, tabs }} className='col-6' onClick={handle.tab} />
      </div>
      <div className='center-h col-8'>
        <Component {...{ ...state, account, integrations }}
          onChange={handle.change}
          onClick={handle.click}
          onRemove={handle.remove}
          onSelectPlan={handle.select}
          onSubmit={handle.submit}
        />
      </div>
      <div className='col-2' />
    </div>
  )
}

export default withRouter(coupler(
  { handlers, initialState, render },
  ['account', 'integrations'],
  ['getAccount', 'getIntegrations', 'removeIntegration', 'updateAccount']
))
